import { Box, Grid, Typography } from "@mui/material";
import React, { Fragment } from "react";
import { MetaTags } from "react-meta-tags";
import LayoutOne from "../../layouts/LayoutOne";
import WhatsAppBotComp from "../../components/WhatsAppBot/YourMainComponent";
import about2 from "../../assets/img/about2.webp";
import Blogcard from "../../components/cards/BlogCard.js";

const Listing = [
  {
    id: 1,
    // blogImage: about2,
    blogTitle: "Reimagining Elegance: The Modern Appeal of Imitation Jewellery",
    blogAuthor: "Team Amyraa",
    blogDate: "September 5, 2024",
    blogLink: "blogdetail",
  },
  // {
  //   id: 2,
  //   blogImage: about2,
  //   blogTitle:
  //     "Top Accessorizing Tips for Enhancing Your Look with Imitation Jewelry",
  //   blogAuthor: "Team Amyraa",
  //   blogDate: "September 5, 2024",
  //   blogLink: "/blogdetail2",
  // },
];

const BlogListings = () => {
  return (
    <Fragment>
      <MetaTags>
        <title>Amyraa | Blogs</title>
        <meta name="description" content="Blogs Listing page ." />
      </MetaTags>
      <LayoutOne>
        <div className="container">
          <Typography
            sx={{
              textAlign: "center",
              justifyContent: "center",
              display: "flex",
              margin: "2rem 0",
              fontFamily: "Montserrat ,sans-serif",
              fontSize: "2.5rem",
              fontWeight: "400",
              fontStyle: "normal",
              lineHeight: "1.2",
              color: "#000",
              backgroundcolor: "#ffffff",
            }}
          >
            Blogs
          </Typography>

          <Grid container spacing={2}>
            {Listing.map((blogs) => (
              <Blogcard
                key={blogs?.id}
                // blogImage={blogs?.blogImage}
                blogTitle={blogs?.blogTitle}
                blogAuthor={blogs?.blogAuthor}
                blogDate={blogs?.blogDate}
                // blogLink={`/blogdetail/${blogs?.id}`}
                blogLink={blogs?.blogLink}
              />
            ))}
          </Grid>
        </div>
      </LayoutOne>
      <WhatsAppBotComp />
    </Fragment>
  );
};

export default BlogListings;
